import { useQuery } from '@tanstack/react-query';

import axiosInstance from '@/axios/axios';
import type { UseAxiosQueryOptions } from '@/utils/typeHelper';

import type { Shops } from '../../../Swagger';

type QueryOptions = UseAxiosQueryOptions<Shops.ShopsDetail.ResponseBody, ['shop', { readonly shopID?: string }]>;

/**
 * 샵을 조회하는 API 입니다.
 *
 * @deprecated useShopInfo 으로 마이그레이션 후, deprecated 제거 하기.
 */
export default function useGetShopInfo(shopID: string | undefined, option?: Partial<QueryOptions>) {
  return useQuery({
    queryKey: ['shop', { shopID: shopID }],
    queryFn: async ({ queryKey }) => {
      const [key, { shopID }] = queryKey;
      return axiosInstance.get<Shops.ShopsDetail.ResponseBody>(`/shops/${shopID}`).then(v => v.data);
    },
    enabled: !!shopID,

    staleTime: 5 * 60 * 1000,

    ...option,
  });
}
